/**
 * Error reports: "this set is not at that time", "this bar is not there".
 *
 * Anyone can send one, signed in or not (CONTENU.md §2), in one gesture from the
 * set or the place it is about (CONTENU.md §4). They wait in the back-office for
 * whoever keeps the page: the organiser of an official festival, a moderator
 * for a community page.
 *
 * The kinds are a short closed list rather than free text: the person reporting
 * is standing in a field, often in the dark, and a list reads in any language.
 * A comment can say more.
 */

export const REPORT_TARGETS = ["PERFORMANCE", "POI", "FESTIVAL"] as const;
export type ReportTarget = (typeof REPORT_TARGETS)[number];

export const REPORT_KINDS = {
  PERFORMANCE: ["WRONG_TIME", "WRONG_STAGE", "CANCELLED", "OTHER"],
  POI: ["WRONG_PLACE", "GONE", "OTHER"],
  FESTIVAL: ["MISSING", "OTHER"],
} as const satisfies Record<ReportTarget, readonly string[]>;

export type ReportKind = (typeof REPORT_KINDS)[ReportTarget][number];

export const ALL_REPORT_KINDS: readonly ReportKind[] = [
  ...new Set(Object.values(REPORT_KINDS).flat()),
];

export const REPORT_COMMENT_MAX = 500;

export const REPORT_STATUSES = ["OPEN", "RESOLVED", "DISMISSED"] as const;
export type ReportStatus = (typeof REPORT_STATUSES)[number];

/** Whether a kind makes sense for what is reported: no "cancelled" bar. */
export function isReportKindFor(
  target: ReportTarget,
  kind: string,
): kind is ReportKind {
  return (REPORT_KINDS[target] as readonly string[]).includes(kind);
}
